import { styled, StyledGrid } from '@raskrask-dk/rr-components'

export const StyledBasisTypeCards = styled('div', {
    m: '0 auto',
    maxW: 850,
    w: '100%',

    '@desktop': {
        [`& > ${StyledGrid}`]: {
            gridTemplateColumns: 'repeat(auto-fit, minmax(175px, 1fr))',
        },
    },
})
